'use client';
import clsx from 'clsx';
import { setDoc } from 'firebase/firestore';
import { useRouter } from 'next/navigation';
import getShoppingCart from './GetShoppingCart';

const AddToShoppingCartButton = ({ children, className, type, id, userID }: { children: React.ReactNode, className?: string, type: "course" | "note", id: string, userID?: string }) => {
    const router = useRouter();
    if (!userID) {
        return <></>
    }

    const addToShoppingCart = async () => {
        const currentShoppingCart = await getShoppingCart(userID);
        const { docRef, data } = currentShoppingCart;

        // Check if item already exists in cart
        const itemExists = data.items.some(item => item.type === type && item.id === id);

        if (!itemExists) {
            const newShoppingCart = {
                items: [...data.items, { type, id }],
                updatedAt: new Date(),
            }

            if (docRef) {
                await setDoc(docRef, newShoppingCart);
            }
        }

        // TODO: Add toast notification

        router.refresh();
        router.push('/shopping-cart');
    }

    return <button className={clsx('cursor-pointer hover:scale-105 transition-normal', className)} onClick={addToShoppingCart}>{children}</button>
}

export default AddToShoppingCartButton;